import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { JwtService } from '@core/services/jwt.service';

/**
 * @title AuthGuard
 * @since 1.0.0
 * 
 * @description The `AuthGuard` class implements the `CanActivate` interface to protect routes from unauthorized access.
 * It uses the `JwtService` to validate the JWT token before allowing access to the route.
 * If the token is invalid or expired, the user will be redirected to the login page.
 */
@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {
	
	/**
	 * @param {JwtService} jwtService - The service for validating JWT tokens.
	 * @since 1.0.0
	 */
	constructor(
		private jwtService: JwtService,
	) { }

	/**
	 * This method checks if the user is authenticated by validating the JWT token.
	 * @returns {boolean} - Returns true if the token is valid, false otherwise.
	 * @since 1.0.0
	 */
	canActivate(): boolean {
        return this.jwtService.validate();
    }
}